export const enum RejectReasons_enum {
  NO_VACANCY = "no_vacancy",
  PRICE_CHANGED = "price_changed",
  NOT_READY = "not_ready",
  OTHER = "other",
}
